<template>
  <v-container class="pt-0">
    <v-row
      ><v-col class="mx-0 px-0 pt-0">
        <v-card
          flat
          class="bar-header"
          :style="{
            background: setBackgoundBox(),
            borderRadius: setBorderRadiusBox(),
          }"
        >
          <v-menu
            transition="slide-y-transition"
            bottom
            :close-on-click="true"
            rounded
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                style="position: absolute; top: 10%; right: 0"
                dark
                v-bind="attrs"
                v-on="on"
              >
                <v-icon>mdi-dots-vertical</v-icon>
              </v-btn>
            </template>
            <v-list>
              <v-list-item @click="goToCancelPage()">
                <v-list-item-title>{{
                  $t("cancelShipment")
                }}</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>

          <v-container>
            <v-btn
              v-if="!inBottomNavbar"
              icon
              color="white"
              style="margin-top: 14px; margin-left: 2px; z-index: 2"
              elevation="2"
              @click="redirectTo"
            >
              <v-icon large>mdi-chevron-left-circle</v-icon>
            </v-btn>

            <v-card-text class="text-center mt-n5">
              <span
                v-if="
                  !customHeader.isUseCustomHeader ||
                  (customHeader.isUseCustomHeader && customHeader.isUseTitle)
                "
                class="text-h6 text-center"
                style="
                  position: absolute;
                  top: 50%;
                  left: 50%;
                  transform: translate(-50%, -50%);
                  font-weight: 600;
                "
                :style="{
                  color: this.customHeader.titleColor,
                  'text-shadow': checkTitleShadow(),
                }"
              >
                {{ $t("statusDelivery") }}
              </span>
            </v-card-text>
          </v-container>
        </v-card>
      </v-col>
    </v-row>

    <v-item-group mandatory>
      <v-container>
        <v-row justify="center" style="margin-top: -50px">
          <v-col
            cols="3"
            class="d-flex justify-center"
            v-for="item in statusMission"
            :key="item.id"
          >
            <v-item v-slot="{ toggle }">
              <v-badge
                :color="site.color"
                :content="item.count"
                bordered
                overlap
              >
                <v-card
                  width="75"
                  height="79"
                  class="pa-2 mx-0 py-4 d-flex flex-column justify-center"
                  elevation="5"
                  rounded="lg"
                  @click="changeStatus(item.code)"
                  :style="
                    status == item.code
                      ? { border: '1px solid', 'border-color': site.color }
                      : { border: '1px solid', 'border-color': 'grey' }
                  "
                >
                  <p
                    @click="toggle"
                    :style="{ 'font-size': '11px' }"
                    class="pa-0 mb-1 text-center black--text"
                    :class="status == item.code ? site.color : 'grey--text'"
                    :fill="skinColorContent"
                  >
                    <v-avatar tile size="25">
                      <v-icon
                        v-if="item.code == 'all'"
                        :color="status == item.code ? site.color : 'grey'"
                        >mdi-longitude</v-icon
                      >
                      <Shipment_Pending_Icon
                        v-if="item.code == 0"
                        :color="status == item.code ? site.color : 'grey'"
                      />
                      <Shipment_Send_Icon
                        v-if="item.code == 1"
                        :color="status == item.code ? site.color : 'grey'"
                      />
                      <Shipment_Success_Icon
                        v-if="item.code == 2"
                        :color="status == item.code ? site.color : 'grey'"
                      />
                    </v-avatar>
                  </p>
                  <p
                    class="mb-0 text-center py-0"
                    :style="{ color: site.color, fontSize: '12px' }"
                    :class="status == item.code ? site.color : 'grey--text'"
                  >
                    {{ $t(item.value) }}
                  </p>
                </v-card>
              </v-badge>
            </v-item>
          </v-col>
        </v-row>
      </v-container>
    </v-item-group>

    <v-container fluid v-if="dataItems.length">
      <v-col
        cols="12"
        sm="10"
        md="10"
        v-for="(item, index) in dataItems"
        :key="index"
        class="px-1 py-1 mx-auto"
      >
        <v-card
          class="mx-auto rounded-lg"
          outlined
          style="border: 1.5px solid; overflow: hidden; gap: 4px"
          :style="{ borderColor: site.color }"
        >
          <v-container>
            <div class="d-flex" style="gap: 12px">
              <div
                class="d-flex justify-center align-center"
                style="width: 100px; min-width: 100px"
              >
                <v-img
                  :cover="true"
                  :aspect-ratio="1"
                  width="100%"
                  :lazy-src="require('@/assets/images/image.png')"
                  :src="item.image_url"
                  style="border-radius: 8px"
                >
                </v-img>
              </div>
              <div class="d-flex flex-column justify-center">
                <div class="my-0">
                  <p
                    class="text-start my-0"
                    :style="{ color: site.color }"
                    style="font-size: 12px"
                  >
                    <span v-if="item.qty > 1"> ({{ item.qty }})</span>
                    {{ item.name }}
                  </p>
                </div>
                <!-- PENDING -->
                <div v-if="item.delivery_status == 'pending'">
                  <p class="text-start my-1" style="font-size: 12px">
                    {{ $t("shippingInProcess") }}
                  </p>
                </div>
                <!-- DELIVERED -->
                <div v-if="item.delivery_status == 'delivered'">
                  <p class="text-start my-1" style="font-size: 12px">
                    {{ $t("statusDeliverySuccess") }}
                  </p>
                </div>
                <!-- CANCELED -->
                <div v-if="item.delivery_status == 'cancel'">
                  <p
                    class="text-start my-1"
                    style="font-size: 12px; color: red"
                  >
                    {{ $t("statusDeliveryCancel") }}
                  </p>
                </div>
                <!-- SENT -->
                <div v-if="item.delivery_status == 'sent'">
                  <p
                    class="text-start my-1"
                    style="font-size: 12px"
                    v-if="item.delivery_name != 'รับที่จุดรับของ'"
                  >
                    <span class="text-start my-1" style="font-size: 12px">
                      ({{
                        item.delivery_name == "ไปรษณีย์ไทย"
                          ? $t("deliveryThailandPost")
                          : item.delivery_name
                      }})
                    </span>
                    <br />
                    {{ $t("trackingNumber") }} {{ item.tracking_number }}
                    <v-icon
                      @click="copyToClipBoard(item.tracking_number)"
                      :color="site.color"
                      x-small
                      >mdi-content-copy</v-icon
                    >
                  </p>
                  <p class="text-start my-1" style="font-size: 12px" v-else>
                    <!-- {{ item.delivery_name }} -->
                    {{
                      item.delivery_name == "รับที่จุดรับของ"
                        ? $t("deliveryPickup")
                        : item.delivery_name
                    }}
                  </p>
                  <v-btn
                    class="text-start white--text"
                    v-if="item.delivery_name != 'รับที่จุดรับของ'"
                    justify="end"
                    x-small
                    :color="site.color"
                    @click="isConfirmReceive(item)"
                    >{{ $t("receiveReward") }}</v-btn
                  >
                </div>

                <p class="text-caption mb-0 mt-1" v-if="item.user">
                  <v-avatar
                    size="20"
                    class="mr-1"
                    style="background-color: black"
                  >
                    <v-img
                      :src="
                        item.user.image_path
                          ? item.user.image_path
                          : defaultImage
                      "
                    ></v-img>
                  </v-avatar>
                  <span class="mt-1" style="font-style: italic">
                    {{ item.user.name }} {{ item.user.surname }}
                  </span>
                </p>
              </div>
            </div>
          </v-container>
        </v-card>
      </v-col>
    </v-container>

    <div v-if="!dataItems.length">
      <v-col class="d-flex justify-center mt-16">
        <v-img
          class="white--text mx-auto mt-10 empty"
          :src="require('@/assets/images/out-of-stock.png')"
          max-width="150px"
        >
        </v-img>
      </v-col>
      <p class="text-center">{{ $t("errDataNotFound") }}</p>
    </div>

    <div>
      <infinite-loading :identifier="infiniteId" @infinite="infiniteHandler">
        <div slot="spinner">{{ $t("waitingLoad") }}...</div>
        <div slot="no-more"></div>
        <div slot="no-results"></div>
      </infinite-loading>
    </div>

    <v-snackbar v-model="copyAlert" :color="site.color">
      <v-icon>mdi-check-circle-outline</v-icon>
      {{ $t("copyText") }}
    </v-snackbar>

    <v-row justify="center">
      <v-dialog v-model="dialogConfirmReceive" persistent max-width="290">
        <v-card>
          <v-card-text
            class="text-center text-h5 font-weight-medium mb-0 pa-4"
            style="color: black"
          >
            {{ $t("confirmReceiveReward") }}<br />
          </v-card-text>
          <v-card-text class="text-center">
            <br />{{ item_receive.name }}</v-card-text
          >
          <v-card-actions class="pb-5">
            <v-spacer></v-spacer>
            <v-btn
              :color="site.color"
              class="rounded-lg white--text"
              depressed
              @click="confirmReceive()"
            >
              {{ $t("confirm") }}
            </v-btn>
            <v-btn
              :color="site.color"
              class="rounded-lg"
              outlined
              @click="dialogConfirmReceive = false"
            >
              {{ $t("cancel") }}
            </v-btn>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>

    <div
      class="fab-container"
      :style="{
        'padding-bottom': showBottomNavbar ? '70px' : '0px',
      }"
    >
      <v-btn
        v-if="checkFloatPanel"
        fab
        dark
        :color="site.color"
        class="mr-6"
        @click="dialogFloatPanel = true"
      >
        <v-icon>mdi-menu</v-icon>
      </v-btn>
    </div>

    <FloatPanel
      :dialog="dialogFloatPanel"
      @onClose="dialogFloatPanel = false"
    />
  </v-container>
</template>

<script>
import InfiniteLoading from "vue-infinite-loading";
import Axios from "@/config/customer-service";
import { mapState } from "vuex";
import Shipment_Pending_Icon from "@/layouts/icon/shipment-pending-icon.vue";
import Shipment_Send_Icon from "@/layouts/icon/shipment-send-icon.vue";
import Shipment_Success_Icon from "@/layouts/icon/shipment-success-icon.vue";
import { adjustHslBrightness } from "@/config/general-function";
import FloatPanel from "@/components/floatPanel.vue";
import {
  checkImage,
  getFontColorBasedOnBg,
  getLandingPage,
} from "../../../config/general-function";

export default {
  inject: ["isAppLoading"],
  components: {
    InfiniteLoading,
    Shipment_Pending_Icon,
    Shipment_Send_Icon,
    Shipment_Success_Icon,
    FloatPanel,
  },
  data: () => ({
    dialogFloatPanel: false,
    skinColorContent: "red",
    data: [],
    drawer: false,
    group: null,
    model: null,
    dataItems: [],
    status: "all",
    dialogConfirmReceive: false,
    item: "",
    item_receive: "",
    next_page_url: "",
    statusMission: "",
    icon: ["mdi-inbox", "mdi-car-hatchback", "mdi-book-check-outline"],
    infiniteId: +new Date(),
    copyAlert: false,
    customHeaderPage: "transport",
    customHeader: {
      isUseCustomHeader: false,
      isUseTitle: true,
      image: null,
      titleColor: "#ffffff",
    },
    previousRouteName: null,
  }),
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      // vm คือตัวแทนของ this
      const currentRouteName = to.name;
      if (from?.fullPath && from?.fullPath !== "/") {
        sessionStorage.setItem(
          currentRouteName + "_prev_route_name",
          from.name
        );
        vm.previousRouteName = from.name;
      } else {
        vm.previousRouteName = sessionStorage.getItem(
          currentRouteName + "_prev_route_name"
        );
      }
    });
  },
  async created() {
    this.status = "all";
    const delivery_status = this.$route.query.delivery_status;
    if (![null, undefined].includes(delivery_status)) {
      this.status = delivery_status;
    }
    this.getStatusSummary();
    // ========== ========== ========== ==========
    if (this.site?.page_header_cover[this.customHeaderPage]) {
      this.customHeader.isUseCustomHeader =
        this.site?.page_header_cover[
          this.customHeaderPage
        ].is_use_custom_header;
      this.customHeader.isUseTitle =
        this.site?.page_header_cover[this.customHeaderPage].is_use_title;
      const page_header_cover_image =
        this.site?.page_header_cover[this.customHeaderPage].image;
      const _check_image = await checkImage(page_header_cover_image);
      this.customHeader.image = _check_image ? page_header_cover_image : null;
      this.customHeader.titleColor = "#ffffff";
      if (this.customHeader.isUseCustomHeader) {
        this.customHeader.titleColor =
          this.site?.page_header_cover[this.customHeaderPage].title_color ||
          "#ffffff";
      }
    }
  },
  methods: {
    redirectTo() {
      if (this.previousRouteName) {
        this.$router.go(-1);
      } else {
        let listRouteName = [];
        if (
          Array.isArray(this.site?.bottom_nav_bar?.menu) &&
          this.site?.bottom_nav_bar?.menu?.length > 0
        ) {
          const listRouteAllow = this.site?.bottom_nav_bar.menu.map(
            (x) => x.route_allow
          );
          for (let item of listRouteAllow) {
            listRouteName = [...listRouteName, ...item];
          }
        }
        if (listRouteName.length > 0) {
          this.$router.push({ name: listRouteName[0] });
        } else {
          const landing_page = getLandingPage();
          const targetRoute = this.$router.resolve({
            name: landing_page,
          });
          window.location.href = targetRoute.href;
        }
      }
    },
    setBackgoundBox() {
      const _color = this.site.color || "#00000";
      const darken = adjustHslBrightness(_color, -20);
      let _style = `linear-gradient(120deg, ${_color}, ${darken})`;
      if (this.customHeader.isUseCustomHeader && this.customHeader.image) {
        _style = `url("${this.customHeader.image}") center / cover no-repeat`;
      }
      return _style;
    },
    checkTitleShadow() {
      let shadow = "rgb(224 224 224) 2px 1px 1px";
      const color = getFontColorBasedOnBg(this.customHeader.titleColor, "bw");
      if (color == "#000000") {
        shadow = "rgb(66, 68, 90) 2px 1px 1px";
      }
      return shadow;
    },
    setBorderRadiusBox() {
      let _style = `0px 0px 25px 25px`;
      if (this.customHeader.isUseCustomHeader && this.customHeader.image) {
        _style = `0px !important`;
      }
      return _style;
    },
    goToCancelPage() {
      this.$router.push({ name: "cancel-shipment" });
    },
    changeStatus(item) {
      console.log(item);
      this.status = item.toString();
      this.initialize();
    },
    infiniteHandler($state) {
      Axios.get("reward/listDeliveryReward", {
        params: {
          status_code: this.status,
          cursor: this.next_page_url,
        },
      }).then(({ data }) => {
        if (data.data.data.length) {
          let has_more = data.data.has_more;
          this.dataItems = this.dataItems.concat(data.data.data);
          if (!has_more) {
            $state.complete();
            return;
          } else {
            this.next_page_url = data.data.next_page_url.split("=")[1];
            $state.loaded();
          }
        } else {
          $state.complete();
        }
      });
    },
    initialize() {
      this.dataItems = [];
      this.next_page_url = "";
      this.infiniteId += 1;
    },
    copyToClipBoard(text) {
      this.copyAlert = true;
      navigator.clipboard.writeText(text);
    },
    isConfirmReceive(item) {
      this.dialogConfirmReceive = true;

      this.item_receive = item;
    },
    getStatusSummary() {
      Axios.get("reward/listDeliveryRewardStatus")
        .then(({ data }) => {
          if (data.status == "success") {
            this.statusMission = data.data;
          }
        })
        .catch((err) => {
          this.$swal.fire({
            icon: "error",
            text: err.response.data.message,
            showConfirmButton: false,
            timer: 3000,
          });
        });
    },
    confirmReceive() {
      this.isAppLoading(true);
      Axios.post(`/reward/updateTrackingStatus`, this.item_receive)
        .then((res) => {
          if (res.data.status === "success") {
            this.$swal.fire({
              icon: "success",
              title: res.data.message,
              showConfirmButton: false,
              timer: 1500,
            });
            this.initialize();
            this.getStatusSummary();
          } else {
            this.$swal.fire(this.$t("error.title"), res.data.error, "error");
          }
          this.dialogConfirmReceive = false;
        })
        .catch((error) => {
          this.$swal.fire(
            this.$t("error.title"),
            error.response.data.error,
            "error"
          );
        })
        .finally(() => {
          this.isAppLoading(false);
        });
    },
  },
  computed: {
    ...mapState("defaultSystem", ["site"]),
    defaultImage() {
      return require("@/assets/images/user.svg");
    },
    inBottomNavbar() {
      let check = false;
      // ========== ========== ========== ==========
      const curRouteName = this.$router.currentRoute.name;
      let listRouteName = [];
      if (
        Array.isArray(this.site?.bottom_nav_bar?.menu) &&
        this.site?.bottom_nav_bar?.menu?.length > 0
      ) {
        const listRouteAllow = this.site?.bottom_nav_bar.menu.map(
          (x) => x.route_allow
        );
        for (let item of listRouteAllow) {
          listRouteName = [...listRouteName, ...item];
        }
      }
      if (listRouteName.length > 0 && listRouteName.includes(curRouteName)) {
        check = true;
      }
      return check;
    },
    showBottomNavbar() {
      let check = false;
      // ========== ========== ========== ==========
      let checkInRoute = true;
      const curRouteName = this.$route.name;
      let listRouteName = [];
      if (
        Array.isArray(this.site?.bottom_nav_bar?.menu) &&
        this.site?.bottom_nav_bar?.menu?.length > 0
      ) {
        const listRouteAllow = this.site?.bottom_nav_bar.menu.map(
          (x) => x.route_allow
        );
        for (let item of listRouteAllow) {
          listRouteName = [...listRouteName, ...item];
        }
      }
      if (listRouteName.length > 0 && !listRouteName.includes(curRouteName)) {
        checkInRoute = false;
      }
      // ========== ========== ========== ==========
      if (this.site.is_use_bottom_nav && checkInRoute) {
        check = true;
      }
      return check;
    },
    checkFloatPanel() {
      let check = false;
      if (this.site.is_use_float_panel) {
        const float_panel_main_menu = this.site.float_panel_main?.menu || [];
        const float_panel_extend_menu =
          this.site.float_panel_extend?.menu || [];
        const model_main_all_open = float_panel_main_menu.find((x) => x.show);
        const model_extend_all_open = float_panel_extend_menu.find(
          (x) => x.show
        );
        if (model_main_all_open || model_extend_all_open) {
          check = true;
        }
      }
      return check;
    },
  },
};
</script>

<style scoped>
.fab-container {
  position: fixed;
  bottom: 16px;
  right: 0px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  z-index: 1;
}

.bar-header {
  height: 150px;
  font-size: 14px;
}
.v-btn-toggle:not(.v-btn-toggle--dense) .v-btn.v-btn.v-size--default {
  opacity: 1 !important;
  -webkit-box-shadow: rgb(0 0 0 / 24%) 0 3px 8px;
  box-shadow: 0 3px 8pxrgba (0, 0, 0, 0.24);
  border-radius: 10px !important;
  height: 80px;
  min-width: 95px;
  border-radius: 10px;
}
.v-slide-group__content {
  justify-content: center !important;
}
.v-btn-toggle--group > .v-btn.v-btn {
  background-color: white !important;
  border-color: transparent;
}
.empty {
  opacity: 1;
}
</style>
